var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-page-status-list ut-flex",staticStyle:{"height":"100%","min-height":"35px"}},_vm._l((_vm.statusTV),function(invs){return _c('div',{key:invs.key,staticClass:"dt-page-status ut-flex"},[_c('div',{staticClass:"circle",style:({
        backgroundColor: _vm.detectColorValue(invs.value)
          ? invs.value
          : ("#" + (invs.value)),
      })}),_c('div',{staticClass:"status-name"},[_vm._v(_vm._s(invs.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }